const React = require('react');
const { createElement: h, useState } = React;
const AuthBrand = require('./AuthBrand');
require('./LoginPage.css');

// Standalone page reached from the password-reset email link
// (/reset-password?token=...). Reuses the LoginPage `lp-` styles so it looks
// like the rest of the auth surface. On success it points the user back to
// /login (App handles navigation via onNavigateTo).
function getTokenFromUrl() {
  try {
    return new URLSearchParams(window.location.search).get('token') || '';
  } catch (e) {
    return '';
  }
}

function ResetPasswordPage(props) {
  var t = (props.strings && props.strings.login) || {};
  var [token] = useState(getTokenFromUrl());
  var [password, setPassword] = useState('');
  var [confirm, setConfirm] = useState('');
  var [error, setError] = useState('');
  var [isSubmitting, setIsSubmitting] = useState(false);
  var [done, setDone] = useState(false);

  function goToLogin() {
    if (props.onNavigateTo) props.onNavigateTo('/login');
  }

  function submit(event) {
    event.preventDefault();
    if (password !== confirm) {
      setError(t.resetMismatch);
      return;
    }
    setError('');
    setIsSubmitting(true);
    Promise.resolve(props.onResetPassword(token, password))
      .then(function() { setDone(true); })
      .catch(function(err) {
        setError(err && err.message ? err.message : t.resetMissingToken);
      })
      .finally(function() { setIsSubmitting(false); });
  }

  // Shared "back to sign in" footer link, styled like LoginPage's mode switch
  // so both auth screens share the same navigation affordance.
  var backToLogin = h('p', { className: 'lp-switch' },
    h('button', { className: 'lp-switch__link', type: 'button', onClick: goToLogin }, t.resetGoToLogin)
  );

  // No token in the URL — nothing to reset.
  var bodyNode;
  if (!token) {
    bodyNode = h('div', { className: 'lp-form' },
      h('p', { className: 'lp-error' }, t.resetMissingToken),
      backToLogin
    );
  } else if (done) {
    bodyNode = h('div', { className: 'lp-form' },
      h('p', { className: 'lp-forgot-sent' }, t.resetSuccess),
      h('button', { className: 'lp-submit', type: 'button', onClick: goToLogin }, t.resetGoToLogin)
    );
  } else {
    bodyNode = h('form', { className: 'lp-form', onSubmit: submit },
      h('div', { className: 'lp-field' },
        h('label', { className: 'lp-label', htmlFor: 'rp-password' }, t.resetPasswordPlaceholder),
        h('input', {
          id: 'rp-password',
          className: 'lp-input',
          type: 'password',
          value: password,
          onChange: function(e) { setPassword(e.target.value); },
          placeholder: t.resetPasswordPlaceholder,
          autoComplete: 'new-password',
          required: true,
          minLength: 6
        })
      ),
      h('div', { className: 'lp-field' },
        h('label', { className: 'lp-label', htmlFor: 'rp-confirm' }, t.resetConfirmPlaceholder),
        h('input', {
          id: 'rp-confirm',
          className: 'lp-input',
          type: 'password',
          value: confirm,
          onChange: function(e) { setConfirm(e.target.value); },
          placeholder: t.resetConfirmPlaceholder,
          autoComplete: 'new-password',
          required: true,
          minLength: 6
        })
      ),
      error ? h('p', { className: 'lp-error' }, error) : null,
      h('button', { className: 'lp-submit', type: 'submit', disabled: isSubmitting },
        isSubmitting ? t.resetSubmitting : t.resetSubmit
      ),
      backToLogin
    );
  }

  return h('main', { className: 'lp-root' },
    h('div', { className: 'lp-card lp-card--solo' },
      h('div', { className: 'lp-panel lp-panel--right' },
        h('div', { className: 'lp-form-wrap' },
          h(AuthBrand),
          h('div', { className: 'lp-form-intro' },
            h('h1', { className: 'lp-form-title' }, t.resetTitle),
            h('p', { className: 'lp-form-subtitle' }, t.resetSubtitle)
          ),
          bodyNode
        )
      )
    )
  );
}

module.exports = ResetPasswordPage;
